import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'

SwiperCore.use([Navigation])

interface IVProps {
  imgList: string[]
  activeIndex?: number
  onClick?: () => void
}

interface ICProps {
  imgList: string[]
  onClick?: (idx: number) => void
  activeIndex?: number
}

const ImageCandidates = (props: ICProps) => {
  const { imgList = [], onClick, activeIndex = 0 } = props
  if (imgList.length <= 1) {
    return null
  }
  return (
    <div className="image-candidates">
      {imgList.map((e, index) => (
        <span
          className={`image-candidate ${activeIndex === index ? 'active' : ''}`}
          key={e + index}
          style={{ backgroundImage: `url('${e}')` }}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            e.stopPropagation()
            onClick && onClick(index)
          }}
        />
      ))}
      <style jsx>
        {`
          .image-candidates {
            display: flex;
            flex: 0 0 auto;
            justify-content: flex-start;
            flex-wrap: wrap;
            align-items: center;
            width: 100%;
            height: auto;
            padding-top: 4px;
          }

          .image-candidate {
            width: calc((100% - 64px) / 9);
            height: 66px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 8px;
            margin-top: 8px;
            background-color: rgba(255, 255, 255, 0.2);
            box-sizing: content-box;
            cursor: pointer;
          }

          .image-candidate:last-child {
            margin-right: 0;
          }

          .active {
            position: relative;
          }
          .active::before {
            content: '';
            width: calc(100% + 8px);
            height: 74px;
            border: #ffcc32 4px solid;
            position: absolute;
            top: -4px;
            left: -4px;
          }
        `}
      </style>
    </div>
  )
}

const ImageViewer = (props: IVProps) => {
  const { imgList = [], activeIndex = 0, onClick: handleImageClick } = props
  if (imgList.length === 0) {
    return null
  }
  const [indexNow, setIndexNow] = useState(0)
  const [swiper, setSwiper] = useState<any>(null)

  const onClick = (idx: number) => {
    setIndexNow(idx)
    if (swiper && swiper.slideTo) {
      swiper.slideToLoop(idx)
    }
  }

  useEffect(() => {
    setIndexNow(activeIndex)
  }, [activeIndex])
  return (
    <div className="image-viewer">
      {imgList.length > 1 ? (
        <Swiper
          spaceBetween={16}
          loop={imgList.length > 1}
          simulateTouch={false}
          watchOverflow={true}
          navigation={{
            nextEl: '.image-viewer-next',
            prevEl: '.image-viewer-prev',
          }}
          onSwiper={setSwiper}
          onSlideChange={(swiper) => {
            setIndexNow(swiper.realIndex)
          }}
          initialSlide={activeIndex}
        >
          {imgList.map((e, index) => (
            <SwiperSlide key={e + index}>
              <img
                className="big-image"
                src={e}
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault()
                  e.stopPropagation()
                  handleImageClick && handleImageClick()
                }}
                style={{
                  cursor: 'zoom-out',
                }}
              />
            </SwiperSlide>
          ))}
          <span className="swiper-nav-pre image-viewer-prev" />
          <span className="swiper-nav-next image-viewer-next" />
        </Swiper>
      ) : (
        <img
          className="big-image"
          src={imgList[0]}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            e.stopPropagation()
            handleImageClick && handleImageClick()
          }}
          style={{
            cursor: 'zoom-out',
          }}
        />
      )}
      <ImageCandidates
        imgList={imgList}
        onClick={onClick}
        activeIndex={indexNow}
      />
      <style jsx>
        {`
          .image-viewer {
            width: 100%;
          }

          .big-image {
            width: 100%;
            height: 664px;
            object-fit: contain;
            background-color: black;
            cursor: pointer;
          }

          :global(.image-viewer .swiper-button-prev, .image-viewer
              .swiper-button-next) {
            height: 48px;
            width: 32px;
            opacity: 1;
            background: rgba(0, 0, 0, 0.4);
            margin-top: -24px;
          }
          :global(.image-viewer .swiper-button-prev:after, .image-viewer
              .swiper-button-next:after) {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 12px;
            left: 4px;
            background-image: url(${require('static/left-ic.png')});
            background-size: cover;
            margin: 0;
          }
          :global(.image-viewer .swiper-button-prev:hover, .image-viewer
              .swiper-button-next:hover) {
            background: #f5b330;
            opacity: 1;
          }
          :global(.image-viewer .swiper-button-prev:after) {
            transform: rotateZ(-180deg);
          }
          :global(.image-viewer .swiper-button-disabled) {
            display: none;
          }
        `}
      </style>
    </div>
  )
}

export default ImageViewer
